// Shadow of VLT 8.0.0-alpha.28 Logo.tsx — the LJUSA TIDER mark.
// GENERATED by tools/brand_tenant.py (DR-2026-267); regenerate, don't hand-edit.
// Wrapper markup (Link + img) matches upstream so header/footer CSS applies
// unchanged; isFooterLogo kept for call parity (same asset either way).
// Sizing law: VLT's Colophon renders this img at the asset's INTRINSIC size,
// so the asset is authored at display size (DR-2026-267).
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import logoSrc from '../../../../../assets/home-logo.png';

const messages = defineMessages({
  home: { id: 'Home', defaultMessage: 'Home' },
  logoOf: { id: 'Logo of', defaultMessage: 'Logo of' },
});

const Logo = ({ isFooterLogo }) => {
  const intl = useIntl();
  const site = useSelector((state) => state.site?.data || {});
  const navroot = useSelector((state) => state.navroot?.data);
  const navRootPath = flattenToAppURL(navroot?.navroot?.['@id']) || '/';

  return (
    <Link to={navRootPath} aria-label={intl.formatMessage(messages.home)}>
      <img
        src={logoSrc}
        alt={
          intl.formatMessage(messages.logoOf) +
          ' ' +
          (site['plone.site_title'] || 'LJUSA TIDER')
        }
      />
    </Link>
  );
};

export default Logo;
